// extracted by mini-css-extract-plugin
export default {"container":"item-content-toolbar_container__sUXMi","main-container":"item-content-toolbar_main-container__dIPfR","detail-container":"item-content-toolbar_detail-container__Ubzc9"};